const Button = ({ text, outline }) => {
    return (
        <div className={`px-16 py-6 rounded-[60px] ${outline ? 'border-[1px] border-[#F2F3F2]' : ''} bg-[${!outline ? '#F2F3F2' : 'none'}] ${outline ? 'button' : 'button_white'} text-[${!outline ? '#0B1626' : '#F2F3F2'}]`}>
            {text} <svg width="29" height="31" viewBox="0 0 29 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_825_2243)">
                    <path d="M6.75035 24.7496L23.2495 8.25049" stroke={`${!outline ? '#0B1626' : '#F2F3F2'}`} stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M6.75035 8.25042L23.2495 8.25042L23.2495 24.7496" stroke={`${!outline ? '#0B1626' : '#F2F3F2'}`} stroke-linecap="round" stroke-linejoin="round" />
                </g>
                <defs>
                    <clipPath id="clip0_825_2243">
                        <rect width="29" height="31" fill="white" transform="translate(29 31) rotate(-180)" />
                    </clipPath>
                </defs>
            </svg>

        </div>
    );
};
export default Button;
